import React, { useEffect, useState } from 'react';
import '../Style/installPrompt.css';

function InstallAppPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIos, setIsIos] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();

    const iosDevice = /iphone|ipad|ipod/.test(userAgent);
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    setIsIos(iosDevice);
    setIsStandalone(standalone);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (isStandalone) return;

    if (deferredPrompt) {
      deferredPrompt.prompt();

      const choice = await deferredPrompt.userChoice;
      console.log('Install choice:', choice.outcome);

      setDeferredPrompt(null);
      return;
    }

    setShowInstructions(true);
  };

  if (isStandalone) return null;

  return (
    <div className="install-app-card">
      <div>
        <h3>Install GLPT</h3>
        <p>Add GLPT to your home screen for a faster app-like experience.</p>
      </div>

      <button className="install-app-btn" onClick={handleInstallClick}>
        Install App
      </button>

      {showInstructions && (
        <div className="install-instructions">
          {isIos ? (
            <>
              <p>
                On iPhone or iPad: tap the <strong>Share</strong> button, then choose{' '}
                <strong>Add to Home Screen</strong>.
              </p>
            </>
          ) : (
            <>
              <p>
                Open your browser menu and choose <strong>Install app</strong> or{' '}
                <strong>Add to Home screen</strong>.
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default InstallAppPrompt;
